import classnames from 'classnames'
import * as React from 'react'

import { TableAlign, TableHead, TableHeader, TableHeaderSortable } from '../../components/Table'
import { FinancialsColumnDefinition } from '../../components/financials-table/types'
import { SortByShape } from '../../hooks/use-sort-data'
import { SortDirection } from '../../types'
import { TrafficSubRowDataType } from './types'

type Props = {
  columns: FinancialsColumnDefinition<TrafficSubRowDataType>[]
  sort: SortByShape<FinancialsColumnDefinition<TrafficSubRowDataType> | null>
  stickyLabelWidthClassName?: string
  onSortChange: (column: FinancialsColumnDefinition<TrafficSubRowDataType>) => void
}

export function TrafficTableHead({ columns, sort, stickyLabelWidthClassName, onSortChange }: Props) {
  const handleChangeSort = (column: FinancialsColumnDefinition<TrafficSubRowDataType>) => {
    const shouldRemoveOrder = sort.direction === SortDirection.Descending && column === sort.column
    if (shouldRemoveOrder) {
      onSortChange('order' as unknown as FinancialsColumnDefinition)
    } else {
      onSortChange(column)
    }
  }

  return (
    <TableHead>
      <TableHeader align={TableAlign.Left} className={classnames(stickyLabelWidthClassName, 'bg-primary')} isSticky />

      {columns.map((column) => (
        <TableHeaderSortable
          key={column.id}
          align={column.align}
          className={column.className}
          isActive={column.id === sort.column?.id}
          direction={sort.direction}
          onClick={() => handleChangeSort(column)}
        >
          {column.name}
        </TableHeaderSortable>
      ))}
    </TableHead>
  )
}
